<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.4 4H14.6C15.37 4 16 4.5625 16 5.25V12.75C16 13.4375 15.37 14 14.6 14H3.4C2.63 14 2 13.4375 2 12.75V5.25C2 4.5625 2.63 4 3.4 4Z" stroke="#233780" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16 5L9 10L2 5" stroke="#233780" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'MailIcon'
}
</script>
